<template>
  <div>
    <van-nav-bar :border="false"
                 title="通讯录"
                 left-arrow
                 @click-left="$router.back()"
    />
    <ul class="list-mail-menu">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad()"
        >
          <li class="item" v-for="(item,index) in memberList" :key="index">
            <img class="img" :src="item.Item.HeadImgUrl" alt="">
            <div class="info">
              <p class="p1">{{ item.Item.Name }} - {{ item.GovDepItem.Name }}</p>
              <p class="p2"><a :href="'tel:'+item.Item.UserTel" @click.stop><i></i>联系电话：{{ item.Item.UserTel }}</a></p>
            </div>
          </li>
          <!-- <li class="item">
              <img class="img" src="../../assets/avatar.png" alt="">
              <div class="info">
                  <p class="p1">王明 - 技术中心</p>
                  <p class="p2"><i></i>联系电话：<a href="tel:188888888">188888888</a></p>
              </div>
          </li> -->
        </van-list>
      </van-pull-refresh>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pcount: 10,
      allcount: 0,
    }
  },
  mounted() {

  },
  methods: {
    onLoad() {
      console.log('onLoad');
      this.WebGetWorkUserItemLst();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.memberList = [];
      this.onLoad()
    },
    toDetail(sysno) {
      this.$router.push({
        name: 'Duty',
        query: {mode: 'boss', userSysno: sysno}
      })
    },
    WebGetWorkUserItemLst() {
      let data = {
        page: this.page,
        pcount: this.pcount
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetWorkUserItemLst', data, res => {
        console.log(res);
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false
        res = res.WebGetWorkUserItemLstResult
        if (res.ResponseCode == 1) {
          this.allcount = res.AllCount;
          if (res.ItemLst) {
            this.memberList.push(...res.ItemLst)
          }
          if (this.memberList.length >= this.allcount) {
            this.finished = true
          } else {
            this.page++
          }
        } else {
          this.finished = true
        }
      }, err => {
      })
    }
  },
}
</script>

<style lang="less" scoped>
.list-mail-menu {
  padding-left: 0.28rem;
  padding-right: 0.28rem;
  padding-bottom: 0.28rem;

  .item {
    margin-top: 0.28rem;
    padding: .5rem 1rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 0.17rem 0rem rgba(30, 34, 121, 0.13);
    border-radius: 0.27rem;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .img {
      width: 1.47rem;
      height: 1.47rem;
      border-radius: 100%;
      margin-right: 0.9rem;
      object-fit: cover;
    }

    .p1 {
      font-size: 0.4rem;
      color: #333333;
    }

    .p2 {
      margin-top: 0.1rem;
      font-size: 0.3rem;
      color: #666666;

      i {
        display: inline-block;
        vertical-align: middle;
        width: 0.25rem;
        height: 0.25rem;
        margin-right: 0.1rem;
        background-image: url('~@/assets/tel.png');
        background-repeat: no-repeat;
        background-size: contain;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/Mail.vue